// @core/api/endpoints/platform/list_platform_invitations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPlatformInvitationsResponse,
} from '../../../types/platform';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/platform';

/**
 * List platform invitations
 * Returns a paginated list of all invitations sent for the platform. Supports filtering by invitation status.
 */
export async function ListPlatformInvitations(
  platform_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPlatformInvitationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/invitations`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<ListPlatformInvitationsResponse>(requestPath, { ...requestOptions, params });
}
